import React, { useState, useEffect } from 'react'
import {
  TextField,
  Button,
  Typography,
  Paper,
  FormControl
} from '@material-ui/core'
import useStyles from './styles'
import { useNavigate } from 'react-router-dom'
import data from '../../dataLogin.json'
import { URL } from '../../constants/actionTypes'
const LoginForm = ({ checkLogin }) => {
  const navigate = useNavigate()

  const classes = useStyles()

  const [loginData, setLoginData] = useState({
    username: '',
    password: '',
    loginSuccess: false
  })
  const handleSubmit = async (e) => {
    e.preventDefault()
    data.map((item) => {
      if (
        item.username === loginData.username &&
        item.password === loginData.password
      ) {
        // console.log('login success')
        localStorage.setItem('colorMixingHipic', true)

        navigate(URL + '/dashboard')
        checkLogin(true)
      } else {
        console.log('wrong username/password')
      }
    })

    // navigate(URL + '/print', { state: postData })
  }
  useEffect(() => {
    const loginSuccess = JSON.parse(localStorage.getItem('colorMixingHipic'))
    // console.log(loginSuccess)
    if (loginSuccess) {
      setLoginData({ ...loginData, loginSuccess })
      navigate(URL + '/dashboard')
      //  navigate(0)
    }
  }, [])

  return (
    <Paper className={classes.paper} style={{ maxWidth: '600px' }}>
      <form
        encType='multipart/form-data'
        autoComplete='off'
        noValidate
        className={`${classes.root} ${classes.form}`}
        onSubmit={handleSubmit}
        style={{
          flexWrap: 'wrap',
          justifyContent: 'center',
          minHeight: 'auto'
        }}
      >
        <Typography
          variant='h6'
          style={{ fontWeight: '700', fontSize: '25px', color: '#fff' }}
        >
          Đăng Nhập
        </Typography>

        <FormControl className={classes.formControl} fullWidth>
          <TextField
            id='demo-simple-select-username'
            className={classes.fileInput}
            name='login'
            variant='outlined'
            label='Username'
            fullWidth
            value={loginData.username}
            onChange={(e) =>
              setLoginData({ ...loginData, username: e.target.value })
            }
          />
        </FormControl>

        <FormControl className={classes.formControl} fullWidth>
          <TextField
            id='demo-simple-select-password'
            className={classes.fileInput}
            name='password'
            variant='outlined'
            label='Password'
            type='password'
            fullWidth
            value={loginData.password}
            onChange={(e) =>
              setLoginData({ ...loginData, password: e.target.value })
            }
            //   onChange={(e) => handleStudentNameChange(e, index)}
          />
        </FormControl>
        <FormControl className={classes.formControl} fullWidth>
          <Button
            className={classes.buttonSubmit}
            variant='contained'
            color='primary'
            size='large'
            type='submit'
            fullWidth
          >
            Đăng Nhập
          </Button>
        </FormControl>
      </form>
    </Paper>
  )
}

export default LoginForm
